var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerTwoFrame4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.685 159.613H336.683C371.308 159.613 399.376 187.682 399.376 222.307C399.376 256.931 371.308 285 336.683 285H204.638C170.422 285 142.685 257.263 142.685 223.047V159.613Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M273.99 79.7186L336.683 79.7186L399.377 79.7186C399.377 114.343 371.308 142.412 336.683 142.412C302.059 142.412 273.99 114.343 273.99 79.7186Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M273.99 62.6935L336.683 62.6935L399.377 62.6935C399.377 28.0688 371.308 2.45385e-06 336.683 5.48084e-06C302.059 8.50782e-06 273.99 28.0688 273.99 62.6935Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.28298 222.123L62.9765 222.123L125.67 222.123C125.67 256.748 97.6011 284.816 62.9764 284.816C28.3518 284.816 0.282977 256.748 0.28298 222.123Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M268.072 136.496L205.378 136.496L142.685 136.496C142.685 101.872 170.753 73.8027 205.378 73.8027C240.003 73.8027 268.072 101.872 268.072 136.496Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerTwoFrame4);
export default __webpack_public_path__ + "static/media/CornerTwoFrame4.0ecae0baad3e29351cde96a64ae5458d.svg";
export { ForwardRef as ReactComponent };